module.exports = __webpack_public_path__ + "static/media/farms-icon.21f6f287.svg";